import { render } from "./CustomModal.vue?vue&type=template&id=5af7311a"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"

import "./CustomModal.vue?vue&type=style&index=0&id=5af7311a&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__